import { Component, Inject, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DBasicosParametricasServicios, DValorPeriodico, DValorDominio } from '@dian/api-basicos-parametricas';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { BeneficiosTributariosDescuentosModalComponent } from '../../beneficios-tributarios/beneficios-tributarios-descuentos/beneficios-tributarios-descuentos-modal.component';
import { BeneficiosIngresosNoGravados } from '../../beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_229';

const stepsList = [
  { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Muebles Leasing', listHelp: ['621', '622', '623', '624', '625', '626', '631'] },

];
const tableStructure = [
  { id: 'entidad', title: 'Entidad' },
  { id: 'tipoRentaPasivaECE', title: 'Tipo renta' },
  { id: 'ingresoPasivo', title: 'Ingreso Pasivo' },
  { id: 'valDeclarar', title: 'Valor a declarar' },
];

class ArticulosDominio {
  valor: number;
  nombre: string;
}

class Form1 {
  id: number;
  entidad: string;
  ingresoPasivo: string;
  tipoRentaECE: string;
  tipoRentaPasivaECE: string;
  impPagadoExterior: string;
  valDeclarar: string;
}
@Component({
  selector: 'app-ingresos-rentas-pasivas-ECE-modal',
  templateUrl: './ingresos-rentas-pasivas-ECE-modal.component.html',
  styleUrls: ['./ingresos-rentas-pasivas-ECE-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    DValorDominio,
    ComponentFactoryService

  ]
})
export class IngresosRentasPasivasECEModalComponent extends HandlerModal implements OnInit {
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public lisTipRentaPasivaECE: DValorDominio[] = [];

  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;
  mensajeTabla = "Agregue, edite o elimine sus ingresos según su realidad económica.";

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave: boolean;


  constructor(
    public dialogRef: MatDialogRef<IngresosRentasPasivasECEModalComponent>,
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    private _componentFactory: ComponentFactoryService,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(this.model);

  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    /*  this.validateBtnRightActive();
     this.validateShowSave(); */

    
    if (this.lisTipRentaPasivaECE && this.lisTipRentaPasivaECE.length>0) {
      this.lisTipRentaPasivaECE = this.lisTipRentaPasivaECE.filter(item => Number(item.valor) == 3 || Number(item.valor) == 4 || Number(item.valor) == 6 );
      }
      console.log("Lista Renta Pasiva ECE 2= ", this.lisTipRentaPasivaECE);
  }
  
  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.entidad = "";
    this.modelForm.tipoRentaECE = "";
    this.modelForm.ingresoPasivo = "0";
    this.modelForm.valDeclarar = "0";
    this.modelForm.impPagadoExterior = "0";
    this.modelForm.tipoRentaPasivaECE = "";
    /*  this.reloadSelArticulos(); */
  }


  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_622 == undefined) {

      this.model.doc.cuerpo.cc_id_622 = []; //Entidad
      this.model.doc.cuerpo.cc_id_623 = []; //Tipo de Renta ECE
      this.model.doc.cuerpo.cc_id_624 = []; //Ingreso Pasivo
      this.model.doc.cuerpo.cc_id_625 = []; //Valor Declarado Item 
      this.model.doc.cuerpo.cc_id_631 = []; //Impuesto Pagado en el Exterior
      this.model.doc.cuerpo.cs_id_626 = "0";  //Valor total

    }
  }

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    console.log(this.lisTipRentaPasivaECE);
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_622.length; i++) {
      this.modelForm.id = i;
      this.modelForm.entidad = this.model.doc.cuerpo.cc_id_622[i].v;      
      if(this.lisTipRentaPasivaECE && this.lisTipRentaPasivaECE.length>0){
        const tipoRenta = this.lisTipRentaPasivaECE.find(item => item.valor == this.model.doc.cuerpo.cc_id_623[i].v);
        this.modelForm.tipoRentaPasivaECE = tipoRenta ? tipoRenta.nombre : '';
      }      
      this.modelForm.tipoRentaECE = this.model.doc.cuerpo.cc_id_623[i].v;
      this.modelForm.ingresoPasivo = this.model.doc.cuerpo.cc_id_624[i].v;
      this.modelForm.valDeclarar = this.model.doc.cuerpo.cc_id_625[i].v;
      this.modelForm.impPagadoExterior = this.model.doc.cuerpo.cc_id_631[i].v;
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }
  public editModeloDesdeForm() {
    this.model.doc.cuerpo.cc_id_622[this.modelForm.id].v = this.modelForm.entidad.toString();
    this.model.doc.cuerpo.cc_id_623[this.modelForm.id].v = this.modelForm.tipoRentaECE.toString();
    this.model.doc.cuerpo.cc_id_624[this.modelForm.id].v = this.modelForm.ingresoPasivo.toString();
    this.model.doc.cuerpo.cc_id_625[this.modelForm.id].v = this.modelForm.valDeclarar.toString();
    this.model.doc.cuerpo.cc_id_631[this.modelForm.id].v = this.modelForm.impPagadoExterior.toString();

  }
  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.model.doc.cuerpo.cc_id_622.push({ it: i, v: this.modelForm.entidad });
    this.model.doc.cuerpo.cc_id_623.push({ it: i, v: this.modelForm.tipoRentaECE.toString() });
    this.model.doc.cuerpo.cc_id_624.push({ it: i, v: this.modelForm.ingresoPasivo.toString() });
    this.model.doc.cuerpo.cc_id_625.push({ it: i, v: this.modelForm.valDeclarar.toString() });
    this.model.doc.cuerpo.cc_id_631.push({ it: i, v: this.modelForm.impPagadoExterior.toString() });
  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_622.splice(index, 1);
    this.model.doc.cuerpo.cc_id_623.splice(index, 1);
    this.model.doc.cuerpo.cc_id_624.splice(index, 1);
    this.model.doc.cuerpo.cc_id_625.splice(index, 1);
    this.model.doc.cuerpo.cc_id_631.splice(index, 1);


    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_622.length; i++) {
      this.model.doc.cuerpo.cc_id_622[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_623[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_624[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_625[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_631[i].it = i + 1;
    }
  }

  public validateFormCompleted(): boolean {
    return this.modelForm.entidad == undefined || this.modelForm.entidad == null || this.modelForm.entidad.trim() == "" ||
      this.modelForm.tipoRentaECE == undefined || this.modelForm.tipoRentaECE == null ||
      this.modelForm.ingresoPasivo == undefined || this.modelForm.ingresoPasivo == null || this.modelForm.ingresoPasivo == "0" ||
      this.modelForm.valDeclarar == undefined || this.modelForm.valDeclarar == null || this.modelForm.valDeclarar == "0" ||
      this.modelForm.impPagadoExterior == undefined || this.modelForm.impPagadoExterior == null

  }

  public redondearFormData() {
    this.modelForm.ingresoPasivo = this.dutilidades.redondearValorMoneda(this.modelForm.ingresoPasivo.toString(), true);
    this.modelForm.valDeclarar = this.dutilidades.redondearValorMoneda(this.modelForm.valDeclarar.toString(), true);
    this.modelForm.impPagadoExterior = this.dutilidades.redondearValorMoneda(this.modelForm.impPagadoExterior.toString(), true);

  }

  saveItem(): void {
    if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();
      //this.listaTipoRenta.find(item => item.valor.toString() == this.modelForm.tipoRenta).nombre;
      this.modelForm.tipoRentaPasivaECE = this.lisTipRentaPasivaECE.find(item => item.valor.toString() == this.modelForm.tipoRentaECE).nombre;
      //this.modelForm.tipoRentaPasivaECE = this.lisTipRentaPasivaECE[Number(this.modelForm.tipoRentaECE)].nombre;
      if (this.operacionTabla == this.OPERACION_EDITAR) {
        this.dataSourceBody.forEach((el) => {
          if (el.id == this.modelForm.id) {
            el = this.modelForm;
          }
        });
      } else if (this.operacionTabla == this.OPERACION_AGREGAR) {
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs626();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
      console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs626();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];
      //this.reloadSelArticulos(true);
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      //this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }

  operacionCs626() {
    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valDeclarar, suma);
    }
    this.model.doc.cuerpo.cs_id_626 = suma;

  }

  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected controlStep(direction: DirectionType): void {

  }


  public closeModal() {
    this.initializeTablaDesdeModelo();
    this.operacionCs626();
    //this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar() {
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_622 = undefined;
    this.inicializeModelo();
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCs626();

    /* const componentBenIngNoRenta= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });
    componentBenIngNoRenta.instance.reset();
    componentBenIngNoRenta.instance.initializeTablaDesdeModelo();
    componentBenIngNoRenta.instance.uvt = "42412";
    componentBenIngNoRenta.instance.operacionCS691();
    componentBenIngNoRenta.instance.operacionCS676(); */

    console.log(this.model.doc.cuerpo.cs_id_691)
    /*    const componentBeneficiosDescuentos = this._componentFactory.createModalComponent(BeneficiosTributariosDescuentosModalComponent,   this.model );
       componentBeneficiosDescuentos.instance.actualizarDataRentPasi(); */
    this.saveModel.emit(true);
    this.closeModal();

  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-rentas-pasivas-ECE-modal/ingresos-rentas-pasivas-ECE-modal.component.ts